

























import { Component, Vue } from 'vue-property-decorator';
import Main from '@/views/Main.vue';
import {ServiceWorkerCustomHooks} from '@/registerServiceWorker';

@Component({
  components: {
    Main,
  },
})
export default class App extends Vue {

    public isAppUpdateDialogVisible: boolean = false;
    public serviceWorkerRegistration: any = null;

    // noinspection JSUnusedGlobalSymbols
    public mounted() {
        ServiceWorkerCustomHooks.registerUpdatedHook((registration: any) => {
            this.isAppUpdateDialogVisible = true;
            this.serviceWorkerRegistration = registration;
        });
    }

    public updateApplication() {
        window.console.log(this.serviceWorkerRegistration);
        if (this.serviceWorkerRegistration === null) {
            return;
        }
        window.console.log(123);
        this.serviceWorkerRegistration.waiting.postMessage({action: 'skipWaiting'});
    }
}
